import { createContext, useContext } from 'react';

/**
 * Provides the `document` reference for the current rendering context.
 * In the main window this is the global `document`. Inside a PanelPortal it
 * is the popup window's document — enabling DOM queries (e.g. getElementById)
 * to resolve inside the correct window.
 */
export const WindowDocumentContext = createContext<Document>(
  typeof document !== 'undefined' ? document : (null as unknown as Document),
);

export const useWindowDocument = (): Document => useContext(WindowDocumentContext);
